import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './common/SafeIcon';
import './App.css';

const { FiCheck, FiCalendar, FiMail, FiUsers, FiArrowRight, FiStar, FiX } = FiIcons;

function App() {
  const [showPopup, setShowPopup] = useState(false);

  const handleWhatsAppClick = () => {
    window.open('https://abdul.cc/10XAI_AGENT_WHATSAPP_COM', '_blank');
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 10000); // 10 seconds

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50">
      {/* Header */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-4xl mx-auto px-4 py-4">
          <div className="flex items-center justify-center">
            <h1 className="text-2xl font-bold text-gray-800">10xAI Founder</h1>
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 py-8">
        {/* Main Congratulations Section */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <div className="bg-green-100 border-2 border-green-300 rounded-2xl p-8 mb-8">
            <div className="flex justify-center mb-4">
              <div className="bg-green-500 rounded-full p-4">
                <SafeIcon icon={FiCheck} className="text-4xl text-white" />
              </div>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-green-700 mb-4">
              Congratulations! 🎉
            </h1>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">
              நீங்க உள்ள வந்தாச்சு! (You're In!)
            </h2>
            <p className="text-xl text-gray-700 leading-relaxed max-w-3xl mx-auto">
              AI பயன்படுத்தி உங்க business-ஐ அடுத்த கட்டத்திற்கு கொண்டு செல்ல, 
              முதல் படியை வெற்றிகரமாக எடுத்துள்ளீர்கள்! 🚀
            </p>
            <p className="text-lg text-gray-600 mt-4">
              (You have successfully taken the first step to take your business to the next level using AI!)
            </p>
          </div>
        </motion.div>

        {/* Payment Confirmation */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="bg-white rounded-xl shadow-lg p-6 mb-8"
        >
          <div className="flex items-center justify-between">
            <div>
              <h3 className="text-xl font-semibold text-gray-800">Payment Confirmed ✅</h3>
            </div>
            <div className="text-green-500 text-3xl">
              <SafeIcon icon={FiCheck} />
            </div>
          </div>
        </motion.div>

        {/* Next Steps Section */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="bg-white rounded-xl shadow-lg p-8 mb-8"
        >
          <h3 className="text-2xl font-bold text-gray-800 mb-6 text-center">
            அடுத்த படிகள் (Next Steps) 📋
          </h3>
          
          <div className="space-y-6">
            {/* Step 1 */}
            <div className="flex items-start space-x-4 p-4 bg-blue-50 rounded-lg">
              <div className="bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold">1</div>
              <div>
                <h4 className="text-lg font-semibold text-gray-800 flex items-center">
                  <SafeIcon icon={FiMail} className="mr-2" />
                  Check Your Email 📧
                </h4>
                <p className="text-gray-600 mt-1">
                  Payment receipt மற்றும் workshop confirmation email உங்க inbox-ல் வந்துருக்கும். 
                  Check பண்ணுங்க!
                </p>
              </div>
            </div>

            {/* Step 2 */}
            <div className="flex items-start space-x-4 p-4 bg-purple-50 rounded-lg">
              <div className="bg-purple-500 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold">2</div>
              <div>
                <h4 className="text-lg font-semibold text-gray-800 flex items-center">
                  <SafeIcon icon={FiCalendar} className="mr-2" />
                  Mark Your Calendar 📅
                </h4>
                <p className="text-gray-600 mt-1">
                  <strong>Sunday at 10 AM IST</strong> - இந்த time-ஐ மறக்காதீங்க! 
                  Calendar-ல் reminder set பண்ணுங்க.
                </p>
              </div>
            </div>

            {/* Step 3 - Most Important */}
            <div className="flex items-start space-x-4 p-4 bg-gradient-to-r from-orange-50 to-red-50 rounded-lg border-2 border-orange-200">
              <div className="bg-red-500 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold">3</div>
              <div>
                <h4 className="text-lg font-semibold text-gray-800 flex items-center">
                  <SafeIcon icon={FiUsers} className="mr-2" />
                  Join the Community (மிக முக்கியம்!) 🔥
                </h4>
                <p className="text-gray-600 mt-1">
                  <strong>இதுதான் மிக முக்கியமான step!</strong> Workshop-க்கு முன்னாடியே 
                  full value பெற இது அவசியம்.
                </p>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Main CTA - WhatsApp Community */}
        <motion.div 
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="bg-gradient-to-r from-green-500 to-green-600 rounded-xl shadow-xl p-8 text-white mb-8"
        >
          <div className="text-center">
            <h3 className="text-3xl font-bold mb-4">
              🔥 முக்கியமான கடைசி படி (The Final Important Step!)
            </h3>
            
            <div className="bg-white/10 rounded-lg p-6 mb-6">
              <p className="text-lg leading-relaxed mb-4">
                WhatsApp community-ல் join ஆகி இந்த exclusive benefits-ஐ பெறுங்க:
              </p>
              
              <div className="grid md:grid-cols-2 gap-4 text-left">
                <div className="flex items-start space-x-2">
                  <SafeIcon icon={FiCheck} className="text-green-300 mt-1" />
                  <span>Direct workshop links & reminders</span>
                </div>
                <div className="flex items-start space-x-2">
                  <SafeIcon icon={FiCheck} className="text-green-300 mt-1" />
                  <span>Exclusive pre-workshop AI tools info</span>
                </div>
                <div className="flex items-start space-x-2">
                  <SafeIcon icon={FiCheck} className="text-green-300 mt-1" />
                  <span>Network with Tamil entrepreneurs</span>
                </div>
                <div className="flex items-start space-x-2">
                  <SafeIcon icon={FiCheck} className="text-green-300 mt-1" />
                  <span>Direct access to Abdul Hakkim</span>
                </div>
              </div>
            </div>

            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={handleWhatsAppClick}
              className="bg-white text-green-600 font-bold text-xl px-8 py-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center mx-auto space-x-2"
            >
              <span>🚀 Yes, Add Me to the WhatsApp Community!</span>
              <SafeIcon icon={FiArrowRight} />
            </motion.button>

            <p className="text-green-100 mt-4 text-sm">
              Click above to join 500+ Tamil entrepreneurs! 👆
            </p>
          </div>
        </motion.div>

        {/* Value Reinforcement */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.8 }}
          className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl shadow-xl p-8 text-white text-center mb-8"
        >
          <div className="flex justify-center mb-4">
            <SafeIcon icon={FiStar} className="text-4xl text-yellow-300" />
          </div>
          <h3 className="text-2xl font-bold mb-4">Get Ready for Transformation! 🚀</h3>
          <p className="text-xl leading-relaxed">
            Manual work-க்கு bye-bye சொல்லுங்க! AI automation மூலம் உங்க revenue-ஐ 
            10 மடங்கு அதிகரிக்க தயாராகுங்கள். 💪
          </p>
          <p className="text-lg mt-4 text-blue-100">
            See you live on Sunday! 🔥
          </p>
        </motion.div>

        {/* Secondary CTA */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 1.0 }}
          className="text-center mb-8"
        >
          <p className="text-gray-600 mb-4">
            Haven't joined the WhatsApp community yet? Don't miss out!
          </p>
          <button
            onClick={handleWhatsAppClick}
            className="bg-green-500 text-white font-semibold px-6 py-3 rounded-full hover:bg-green-600 transition-colors duration-300 inline-flex items-center space-x-2"
          >
            <span>✅ இப்போதே WhatsApp-ல் இணையுங்கள்</span>
            <SafeIcon icon={FiArrowRight} />
          </button>
        </motion.div>

        {/* Footer */}
        <motion.div 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 1.2 }}
          className="border-t pt-8 mt-12 text-center text-gray-600"
        >
          <p className="mb-2">
            Questions? Contact us at: 
            <a href="mailto:support@yinguru.com" className="text-blue-600 hover:underline ml-1">
              support@yinguru.com
            </a>
          </p>
          <p className="text-sm">
            ©2025 10xAI Founder. All rights reserved.
          </p>
        </motion.div>
      </div>

      {/* WhatsApp Community Popup */}
      <AnimatePresence>
        {showPopup && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
          >
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 relative"
            >
              <button
                onClick={closePopup}
                className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-2xl"
              >
                <SafeIcon icon={FiX} />
              </button>

              <div className="text-center">
                <div className="bg-green-100 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-4">
                  <SafeIcon icon={FiUsers} className="text-3xl text-green-600" />
                </div>
                
                <h3 className="text-2xl font-bold text-gray-800 mb-4">
                  Don't Miss Out! 🔥
                </h3>
                
                <p className="text-gray-600 mb-6 leading-relaxed">
                  500+ Tamil entrepreneurs are already in our exclusive WhatsApp community. 
                  Join now to get workshop links, AI tips, and network with like-minded business owners!
                </p>

                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => {
                    handleWhatsAppClick();
                    closePopup();
                  }}
                  className="bg-green-500 text-white font-bold text-lg px-6 py-3 rounded-full w-full hover:bg-green-600 transition-colors duration-300 flex items-center justify-center space-x-2"
                >
                  <span>🚀 Join WhatsApp Community</span>
                  <SafeIcon icon={FiArrowRight} />
                </motion.button>

                <button
                  onClick={closePopup}
                  className="text-gray-500 hover:text-gray-700 mt-4 text-sm underline"
                >
                  I'll join later
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;